import {effect, EffectRef, inject, Injectable, signal, WritableSignal} from "@angular/core";
import {ApiService} from "./api.service";
import {ToasterService} from "./toaster.service";
import {take} from "rxjs";
import {SystemAnnouncementResource} from "../types/announcements-types/systemAnnouncementResource";
import {LanguageService} from "./language.service";
import {SystemAnnouncementPriority} from "../types/announcements-types/systemAnnouncementPriority";
import {ToastComponent} from "@syncfusion/ej2-angular-notifications";

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private api: ApiService = inject(ApiService);
  private toaster: ToasterService = inject(ToasterService);
  private languageService: LanguageService = inject(LanguageService);
  
  private data: WritableSignal<SystemAnnouncementResource[] | undefined> = signal<SystemAnnouncementResource[] | undefined>(undefined);
  private openToasts: ToastComponent[] = [];

  public runMaintenanceCheck(): void {
    // Close any existing open toasts
    this.closeAllMaintenanceToasts();
    
    this.api.getMaintenanceInfo()
    .pipe(take(1))
    .subscribe({
      next: (maintenanceInfo) => {
        this.data.set(maintenanceInfo);
      },
      error: (error) => {
        console.error('Error fetching maintenance info:', error);
      }
    });
  }

  private closeAllMaintenanceToasts(): void {
    this.openToasts.forEach((toast) => {
      toast.destroy();
    });
    this.openToasts = [];
  }

  private dataEffect: EffectRef = effect(() => {
    this.data()?.forEach((announcement) => {
      const toasterOptions = {
        timeOut: 0,
        showCloseButton: true,
        link: announcement.link ?? '',
      };

      const announcementMessage = `
        ${this.languageService.getTranslationByKey('MAINTENANCESTART')} ${new Date(announcement.start_at).toLocaleString()},<br> 
        ${this.languageService.getTranslationByKey('MAINTENANCEEND')} ${new Date(announcement.end_at).toLocaleString()},<br>
        ${announcement.description ?? ''}
      `;
  
      let toast: ToastComponent;
      switch(announcement.priority) {
        case SystemAnnouncementPriority.Low:
          toast = this.toaster.info(announcement.title, announcementMessage, toasterOptions);
          break;
        case SystemAnnouncementPriority.Normal:
          toast = this.toaster.warning(announcement.title, announcementMessage, toasterOptions);
          break;
        case SystemAnnouncementPriority.High:
          toast = this.toaster.error(announcement.title, announcementMessage, toasterOptions);
          break;
        default:
          toast = this.toaster.info(announcement.title, announcementMessage, toasterOptions);
          break;
      }
      this.openToasts.push(toast);
    });
  })
}